/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Klaviyo Back In Stock - proxy click to open form directly
  document.addEventListener('click', function(e) {
    var bisButton = e.target.closest('.js-klaviyo-bis-open');
    if (!bisButton) return;
    e.preventDefault();

    var isProductPage = window.location.pathname.includes('/products/');

    if (isProductPage) {
      // On product pages: proxy through the hidden trigger
      var wrapper = bisButton.closest('.product__submit__buttons');
      if (!wrapper) return;

      var trigger = wrapper.querySelector('.klaviyo-bis-trigger');
      if (!trigger) return;

      // Save scroll position before clicking
      var scrollX = window.scrollX;
      var scrollY = window.scrollY;

      // Make trigger temporarily clickable and click it
      trigger.style.setProperty('pointer-events', 'auto', 'important');
      trigger.click();

      // Restore scroll position
      requestAnimationFrame(function() {
        window.scrollTo(scrollX, scrollY);
      });

      // Wait for Klaviyo to inject its button container, then auto-click
      var attempts = 0;
      var interval = setInterval(function() {
        attempts++;
        var klaviyoContainer = document.getElementById('klaviyo-bis-button-container');
        if (klaviyoContainer) {
          var klaviyoBtn = klaviyoContainer.querySelector('button');
          if (klaviyoBtn) {
            clearInterval(interval);
            klaviyoBtn.click();
            trigger.style.setProperty('pointer-events', 'none', 'important');
            // Restore again after Klaviyo's button click
            requestAnimationFrame(function() {
              window.scrollTo(scrollX, scrollY);
            });
          }
        }
        if (attempts >= 30) {
          clearInterval(interval);
          trigger.style.setProperty('pointer-events', 'none', 'important');
        }
      }, 100);
    } else {
      // On non-product pages: open the form directly via Klaviyo API
      var formId = bisButton.getAttribute('data-klaviyo-form-id');
      if (formId && window.klaviyo && window.klaviyo.openForm) {
        window.klaviyo.openForm(formId);
      }
    }
  });

})();